"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _mobx = require("mobx");
var _root_store = _interopRequireDefault(require("./root_store"));
var _class, _descriptor;
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var UserConceptStore = (_class = /*#__PURE__*/function (_RootStore) {
  function UserConceptStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, UserConceptStore);
    _this = _callSuper(this, UserConceptStore);
    (0, _initializerDefineProperty2["default"])(_this, "reviews", _descriptor, _this);
    _this.config = {
      GET: {
        index: '/user_concepts'
      },
      POST: {
        create: '/user_concepts'
      },
      DELETE: {
        destroy_all: '/user_concepts/destroy_all'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(UserConceptStore, _RootStore);
  return (0, _createClass2["default"])(UserConceptStore, [{
    key: "getReviews",
    value: function getReviews() {
      this.api({}, this.afterGetReviews, 'GET', 'reviews');
    }
  }, {
    key: "afterGetReviews",
    value: function afterGetReviews(resp) {
      this.reviews = resp;
    }
  }, {
    key: "destroyAll",
    value: function destroyAll() {
      this.api({}, this.afterDestroyAll.bind(this), 'DELETE', 'destroy_all');
    }
  }, {
    key: "afterDestroyAll",
    value: function afterDestroyAll() {
      this.getIndex();
    }
  }]);
}(_root_store["default"]), _descriptor = (0, _applyDecoratedDescriptor2["default"])(_class.prototype, "reviews", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _class);
var _default = exports["default"] = new UserConceptStore();